/**
 * DA-14933 — реестр данных ключевых точек выбранной смены, ключ — инфра-якорь.
 *
 * В режиме деталей ключевые точки трека (границы сегментов) совпадают с точками
 * инфраструктуры (парковка / СЦ / склад / зарядка), к которым привязаны концы событий.
 * Чтобы не дублировать маркеры, ключевую точку-дубль не рисуем (её представляет точка
 * слоя scr_infra), но при клике по инфра-точке нужно показать атрибуты ключевой точки
 * (время, манипуляции с самокатами). ScrTracksTimeline (владелец сегментов) публикует
 * сюда payload по ключам infra-якорей, а обработчик клика scr_infra в Map.jsx читает.
 *
 * Ключ: `${group}:${id}`, где group ∈ {parking, warehouse, charging} (ключи endpoint_infra),
 * id — public.parkings.id / public.warehouse.id. kind точки scr_infra маппится в group:
 *   parking→parking; service_center|warehouse→warehouse; battery_cabinet|charge_station→charging.
 */
let registry = {};

export const setScrKeyPoints = next => { registry = next || {} };
export const getScrKeyPoint = key => registry[key] || null;
export const clearScrKeyPoints = () => { registry = {} };

// kind точки scr_infra + id → ключ реестра (или null, если вид не маппится).
export const scrInfraRegistryKey = (kind, id) => {
    if (id === null || typeof id === 'undefined') return null;
    if (kind === 'parking') return `parking:${id}`;
    if (kind === 'service_center' || kind === 'warehouse') return `warehouse:${id}`;
    if (kind === 'battery_cabinet' || kind === 'charge_station') return `charging:${id}`;
    return null;
};
